export default "__VITE_ASSET__Dj30zHrz__"